
import Vue from "vue";
import { Component } from "vue-property-decorator";
import UsersGetListResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/UserService/UsersGetListResponse";

@Component
export default class SliderComponent extends Vue {
    name: "custom-toggle-switcher";
  async onChangeBlocked(item: UsersGetListResponse) {
    // this.eventBus.deleteEntity.trigger({id: item.Id});
  }
}
